import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import Login from '../Login/Container'
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    return {
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch) => {
   return {}
}


class Admin extends Component {
    
    render() {

	return (

	    <div style={{maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto'}}>
		<h1>Administracija</h1>

		<Login />

	    </div> 
	    
	)
	

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin/index.jsx